<template>
  <v-app>
    <custom-notification />
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6">
            <v-card :loading="$globalStore.loading" shaped>
              <v-toolbar color="white elevation-0" class="d-flex justify-center">
                <v-toolbar-title centered>
                  <v-avatar color="primary" size="100">
                    <span class="display-1 font-weight-bold white--text">
                      DP
                    </span>
                  </v-avatar>
                </v-toolbar-title>
              </v-toolbar>
              <h1 class="text-center mt-5">Admin Login</h1>
              <v-card-text>
                <custom-form action="api/v1/auth/byEmail" @submitted="onSubmitted">
                  <custom-input
                    :outlined="false"
                    label="User name"
                    prepend-inner-icon="mdi-account-outline"
                    name="email"
                  ></custom-input>

                  <custom-input
                    :outlined="false"
                    label="Password"
                    name="password"
                    prepend-inner-icon="mdi-lock-outline"
                    type="password"
                  ></custom-input>
                  <custom-button color="primary" block large raised tile class="mt-5">
                    Login
                  </custom-button>
                </custom-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$globalStore.user) {
        return next({ name: "dashboard" });
      }
      return next();
    });
  },
  methods: {
    onSubmitted({ access_token, user }) {
      if (!user.is_admin) {
        return window.Notify.error("Unauthorized login!!");
      }
      this.$http.setAuthenticationToken(access_token);
      this.$globalStore.user = user;
      this.$router.push({ name: "dashboard" });
    },
  },
};
</script>
